import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap"
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { toast } from "react-toastify";
import AreaService from "services/Website/AreaServic";
import Select from "react-select";
import { SuccessOk } from "configs/statusCode";



const FilterModal = ({ filterModal, setFilterModal, updateFiltersData, filtersRate }) => {
    const areaService = new AreaService()
    const [areaOptions, setAreaOptions] = useState([])
    const [formData, setFormData] = useState({
        fromRate: "",
        toRate: "",
        areas: ''
    })

    useEffect(() => {
       if(!filtersRate){
        setFormData({
            fromRate: "",
            toRate: "",
            areas: ""
        })
       }else{
        setFormData({
            fromRate: filtersRate.fromRate,
            toRate: filtersRate.toRate,
            areas: filtersRate?.areas
        })
       }
    }, [])

    useEffect(() => {
        areaService.getAreaDropDown().then(res=>{
            if(res.status == SuccessOk){
                const newOptions = res.data.map(item => {
                    return {
                        label: item.name.en ?item.name.en :item.name,
                        value: item.id
                    }
                })
                setAreaOptions(newOptions)
            }
        })
    }, [])

    const handleFieldChange = (e) => {
        const value=e.target.value
        setFormData({ ...formData, [e.target.name]: value });
    };

    return (
        <AvForm className='form-horizontal' >
            <Modal isOpen={filterModal} toggle={() => setFilterModal(!filterModal)}
                className="rightModalSide scrollbar-container mt-0">
                <ModalHeader toggle={() => setFilterModal(!filterModal)}>
                    Rating Filters
            </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12} className='mb-3' >
                            <label>Location</label>
                            <Select
                                placeholder='Select'
                                options={areaOptions}
                                onChange={(data) => {
                                    setFormData({ ...formData, areas: data });
                                }}
                                value={formData.areas}
                                isMulti={true}
                            />
                        </Col>
                        <Col md={12}  >
                            <AvField
                                className="mb-3"
                                name={"fromRate"}
                                label={"From"}
                                bsSize="lg"
                                value={formData.fromRate}
                                onChange={(e => handleFieldChange(e))}
                                 
                                placeholder={'From'}
                                type="number"
                                min={"1"}
                                max={formData.toRate}

                            />
                        </Col>
                        <Col md={12}  >
                            <AvField
                                className="mb-3"
                                name={"toRate"}
                                label={"To"}
                                bsSize="lg"
                                value={formData.toRate}
                                onChange={(e => handleFieldChange(e))}
                                 placeholder={'To'}
                                type="number"
                                min={"1"}
                                 max={"100"}
                            />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                    <button type='button'
                        className='btn btn-light w-120'
                        onClick={() => {
                            setFormData({
                                fromRate: "",
                                toRate: "",
                                areas: ""
                            })
                            updateFiltersData(null)
                         }}>
                        Reset Filter
                     </button>
                    <button type='button'
                        onClick={() => {
                            if(parseInt(formData.toRate)===0 || parseInt(formData.fromRate)===0){
                                toast.error("Rates Must be bigger than zero")
                                return 
                            }if(parseInt(formData.toRate)===1 || parseInt(formData.fromRate)===100){
                                toast.error("invalid rates value")
                                return 
                            }
                            else if(parseInt(formData.fromRate) > parseInt(formData.toRate)  ){
                                   toast.error("To field must be bigger than from field")
                                   return
                           }
                            else if(parseInt(formData.fromRate) < 0 || parseInt(formData.fromRate) > 100 ||
                                parseInt(formData.toRate) < 0 || parseInt(formData.toRate) > 100 ){
                                    toast.error("Rates must be from 1 to 100")
                                    return
                            }else{
                                let data = {
                                    fromRate: formData.fromRate,
                                    toRate: formData.toRate,
                                    areas: formData?.areas
                                }
                                
                                updateFiltersData({...data})
                                setFilterModal(!filterModal)
                            }
                        
                         }} className='btn btn-success  w-120'>
                        Apply Filter
                    </button>
                </ModalFooter>
            </Modal>
        </AvForm>
    )
}
export default FilterModal